export default __webpack_public_path__ + "static/media/Giuseppe Bussolari.5e2284df.jpg";